import React from "react";
import { useArticleHeaderContext } from "../../hooks/articleHeaderContext";
export var FilterWrapper = function (_a) {
    var label = _a.label, onChange = _a.onChange, value = _a.value, visible = _a.visible, children = _a.children;
    var loading = useArticleHeaderContext().loading;
    return (React.createElement("div", { className: "affectBar--filter ".concat(loading ? "loading" : "") },
        React.createElement("div", { className: "affectBar--button ".concat(value ? "small-label" : "large-label"), onClick: function () { return !loading && onChange(!visible); }, onKeyPress: function () { return !loading && onChange(!visible); }, role: "button", tabIndex: 0, "aria-disabled": loading },
            React.createElement("div", { className: "affectBar--button--inner" },
                React.createElement("span", { className: "affectBar--button--label" }, label),
                value && React.createElement("span", { className: "affectBar--value" }, value)),
            React.createElement("div", { className: "affectBar--filter--carat" },
                React.createElement("span", { className: "caret" }))),
        visible && children));
};
